import { FlowChartButton } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'

export const getButtonsFromMap = (
  buttonsIds: string[],
  buttonsMap: Record<string, FlowChartButton>,
): FlowChartButton[] => (buttonsIds || []).map((id) => buttonsMap[id]).filter(Boolean)
